import { useCallback, useRef } from 'react';

export interface SubmitPubSub {
  subscribe: (name: string, callback: any) => void;
  unsubscribe: (name: string) => void;
  publish: (name: string, action: string) => void;
}

// This is an extremely basic pub/sub implementation that we use to send signals between fields on the form
export function useSubmitPubSub() {
  const subscribers = useRef({});

  const subscribe = useCallback((name: string, callback: any) => {
    subscribers.current[name] = callback;
  }, []);

  const unsubscribe = useCallback((name: string) => {
    delete subscribers.current[name];
  }, []);

  const publish = useCallback((name: string, action: string) => {
    if (subscribers.current[name]) {
      subscribers.current[name](action);
    }
  }, []);

  return {
    subscribe,
    unsubscribe,
    publish,
  };
}
